import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { GymsService } from '../services/gyms.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class GymScriptRelListResolver implements Resolve<Observable<string>> {

    constructor(private gymsService: GymsService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.gymsService.getGymsRel(0).catch(() => {
            return Observable.of('error');
        });
    }

}

